export function fetchLoan() {
  const loanRequestOptions = {
    method: "GET",
  };
  const loanUrl = `${import.meta.env.VITE_APPLICATION_API_URI}/loan`;
  return fetch(loanUrl, loanRequestOptions);
}

export function fetchIdentityChalange(uuid) {
  const getIdentityChalangeRequestOptions = {
    method: "GET",
    redirect: "follow",
  };

  const getIdentityChallengeUrl = `${
    import.meta.env.VITE_APPLICATION_API_URI
  }/identity/challenge?uuid=${uuid}`;
  return fetch(getIdentityChallengeUrl, getIdentityChalangeRequestOptions);
}

export function postCodebtors(withoutCodebtors) {
  const codebtorsRequestOptions = {
    method: "POST",
    body: JSON.stringify({ withoutCodebtors: withoutCodebtors }),
  };
  const codebtorsUrl = `${
    import.meta.env.VITE_APPLICATION_API_URI
  }/loan/codebtors`;
  return fetch(codebtorsUrl, codebtorsRequestOptions);
}
